import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { velocityReportEntrypoint } from '@atlassian/jira-spa-apps-next-gen-reports-velocity/entrypoint.tsx';

export const velocityReportPageEntrypoint = createPageEntryPoint({
	main: velocityReportEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
